<template>
  <div class="basicInformation common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>{{ $t('general.BasicInfo') }}</span>
    </div>
    <div class="common_readonly_template">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.an') }}</div>
            <div class="text">{{ basicData.activityCode }}</div>
          </div>
        </el-col>
        <!-- <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.fs') }}</div>
            <div class="text">{{ basicData.financialSystemName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.toc') }}</div>
            <div class="text">{{ basicData.currencyType }}</div>
          </div>
        </el-col> -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.Applicant') }}</div>
            <div class="text">{{ basicData.userData }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.ci') }}</div>
            <div class="text">{{ basicData.applyUserTel }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.at') }}</div>
            <div class="text">{{ basicData.applyTime }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.cs') }}</div>
            <div class="text">{{ basicData.saler }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.businessUnit">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.bu') }}</div>
            <commonTooltip class="text" ref-name="basicDataBusinessUnit" :content="basicData.businessUnit" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.otherClassification">
          <div>
            <div class="label">{{ $t('approvalCenter.copoa') }}</div>
            <div class="text">{{ basicData.otherClassification }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.coa') }}</div>
            <div class="text">{{ basicData.activityClassification }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.relatedActivityName && basicData.relatedActivityCode">
          <div>
            <div class="label">{{ basicData.relationActivityName }}</div>
            <commonTooltip class="text" ref-name="basicDataRelatedActivityName" :content="basicData.relatedActivityName" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.noa') }}</div>
            <commonTooltip class="text" ref-name="basicDataActivityName" :content="basicData.activityName" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.edoh') }}</div>
            <div class="text">{{ basicData.expectStartDate }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.eed') }}</div>
            <div class="text">{{ basicData.expectEndDate }}</div>
          </div>
        </el-col>
        <el-col v-if="lang === 'zh-CN' && !$store.state.useSimplifiedForm" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.hdcdtj') }}</div>
            <div class="text active-text" @click="goToLook">{{ $t('general.ctView') }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.activityBaseName">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.hdjd') }}</div>
            <div class="text">{{ basicData.activityBaseName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.activityBaseContactInformation">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jdlx') }}</div>
            <div class="text">{{ basicData.activityBaseContactInformation }}</div>
          </div>
        </el-col>
        <!-- 如果对应销售是smb则显示 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.salerDeptCode && basicData.salerDeptCode.indexOf('000063') === 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jma') }}</div>
            <div class="text">{{ basicData.isUnionMarket ? "是" : "否" }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.isUnionMarket === 1">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ic') }}</div>
            <div class="text">{{ basicData.isInternationalQd ? "是" : "否" }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.isUnionMarket === 1">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.cst') }}</div>
            <div class="text">{{ basicData.unionChannelType }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.isUnionMarket === 1">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.cn') }}</div>
            <div class="text">{{ basicData.unionChannelName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"  v-if="!belongToSbg && lang === 'zh-CN' && !$store.state.useSimplifiedForm" >
          <div>
            <div class="label">{{ $t('newApp.activityInfo.csl') }}</div>
            <div class="text">{{ basicData.activityLevelName }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import commonTooltip from '@/components/commonTooltip';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
export default {
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    commonTooltip
  },
  data () {
    return {
      basicData: {},
       belongToSbg: false, 
      lang: localStorage.getItem('lang') || 'zh-CN'
    };
  },
  mounted () {
    this.basicData = this.editEchoData.marketActivity;
    this.basicData.userData = `${this.basicData.applyUserName} / ${this.basicData.applyUserDeptName}`;
    this.basicData.saler = `${this.basicData.salerName} / ${this.basicData.salerDeptName}`;
    
    let params = [
      'plate', // 预计板块
      'qd_meeting_segment', // 渠道会议细分
      'activity_type', // 活动类型
      'organizer', // 主办方
      'target_object', // 目标对象
      'other_classification', // 其他分类
      'union_market_help',
      'activity_forms',
      'activity_classification',
      'productline_supplement',
      'activity_goal',
      'expense_detail_item',
      'smb_international_activity_type',
      'activity_level'
    ];
    // 获取活动相关下拉数据（如活动分类、活动层级等）
    newApplicationFormApi.getActivityList(params).then(res => {
      const data = res.data
      // 获取活动分类列表
      const activity_classification = data.activity_classification
      // 在活动分类中查找与当前活动分类编码匹配的项
      const found = activity_classification.find(item => item.fieldKey === this.basicData.activityClassificationCode)
      if (found) {
        // 将匹配到的fieldValue赋值给relationActivityName（活动分类名称）
        this.$set(this.basicData,'relationActivityName',found.fieldValue)
      }
      // 获取活动层级列表
      const activity_level = data.activity_level;
      // 在活动层级中查找与当前活动层级编码匹配的项
      const levelFound = activity_level.find(item => item.fieldKey === this.basicData.activityLevel);
      if (levelFound) {
        // 将匹配到的fieldValue赋值给activityLevelName（活动层级名称）
        this.$set(this.basicData,'activityLevelName',levelFound.fieldValue)
      }
    })
    // switch (this.basicData.activityClassificationCode) {
    //   case 'AC_03':
    //   case 'AC_06':
    //     this.basicData.relationActivityName = '总部活动';
    //     break;
    //   case 'AC_01':
    //     this.basicData.relationActivityName = '模板活动';
    //     break;
    // }
     console.log("this.basicData.salerDeptCode:",this.basicData.salerDeptCode)
          if( this.basicData.salerDeptCode.startsWith("000063")){
                this.belongToSbg = true;
            }else{
              this.belongToSbg = false;
              }
  //  switch (this.basicData.activityLevel) {
  //     case 'A':
  //        this.basicData.activityLevelName = "A类重点活动";
  //       break;
  //     case 'B':
  //       this.basicData.activityLevelName = "B类小型会议";
  //       break;
  //     case 'C':
  //        this.basicData.activityLevelName = "C类关系活动";
  //       break;
  //       case 'D':
  //        this.basicData.activityLevelName = "D类数字营销";
  //       break;
  //   }
    
  },
  methods: {
    goToLook () {
      window.open('https://ruijie.feishu.cn/share/base/query/shrcnLYaqtH3GcUGNq84cJclTTd');
    }
  }
};
</script>

<style lang="scss" scoped>
.active-text{
  color:#14937b;
  cursor: pointer;
}
</style>
